module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/selected-home-property-pin-c262ca3fd1a9f2b96e46ab7c8b91f37c.svg";